import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseInfoIcon = ({ className }: IProps) => (
    <svg
        className={className}
        fill="black"
        height="18"
        viewBox="0 0 24 24"
        width="18"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M12 0C5.3832 0 0 5.38327 0 12.0001C0 18.6169 5.3832 24 12 24C18.6168 24 24 18.6169 24 12.0001C24 5.38327 18.6168 0 12 0ZM12 21.8182C6.58618 21.8182 2.18182 17.4138 2.18182 12.0001C2.18182 6.58633 6.58618 2.18182 12 2.18182C17.4138 2.18182 21.8182 6.58633 21.8182 12.0001C21.8182 17.4138 17.4137 21.8182 12 21.8182Z" />
        <path d="M11.9999 5.09091C11.198 5.09091 10.5457 5.74371 10.5457 6.54611C10.5457 7.34778 11.198 8 11.9999 8C12.8018 8 13.4542 7.34778 13.4542 6.54611C13.4542 5.74371 12.8018 5.09091 11.9999 5.09091Z" />
        <path d="M12 10.1818C11.3975 10.1818 10.9091 10.6703 10.9091 11.2727V17.8182C10.9091 18.4207 11.3975 18.9091 12 18.9091C12.6024 18.9091 13.0909 18.4207 13.0909 17.8182V11.2727C13.0909 10.6703 12.6024 10.1818 12 10.1818Z" />
    </svg>
);

export const InfoIcon = styled(BaseInfoIcon)``;
